// src/components/AboutMeSection.js
import React from 'react';
import MissionVision from './MissionVision';
import StrategicObjectives from './StrategicObjectives';
import CompanyValues from './CompanyValues';
import TeamSection from './TeamSection';
import { companyInfo, strategicObjectives, companyValues } from '../data/companyData';
import { teamMembers } from '../data/teamData';

const AboutMeSection = () => {
  return (
    <section id="sobreMi" className="py-16" style={{ backgroundColor: '#211F1F' }}>
      <div className="container mx-auto px-4">
        
        {/* Título principal */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold mb-3" style={{ color: 'white' }}>
            Sobre <span style={{ color: '#E8B00C' }}>Nosotros</span>
          </h2>
          <div className="w-24 h-1 mx-auto mb-4" style={{ backgroundColor: '#E8B00C' }}></div>
          <p className="text-gray-300 max-w-3xl mx-auto leading-relaxed text-base md:text-lg text-justify">
            {companyInfo.description}
          </p>
        </div>

        {/* Misión y Visión */}
        <MissionVision mission={companyInfo.mission} vision={companyInfo.vision} />

        {/* Objetivos Estratégicos */}
        <StrategicObjectives objectives={strategicObjectives} />

        {/* Valores Corporativos */}
        <CompanyValues values={companyValues} />

        {/* Nuestro Equipo */}
        <TeamSection members={teamMembers} />
        
      </div>
    </section>
  );
};

export default AboutMeSection;